import { APPLY_PRESET_VIEW } from '@src/utils/presets/personalPresets';
import update from 'immutability-helper';
import { DEFAULT_METRIC } from '@utils/constants';
import * as comparisonTypes from '@store/comparison/types';
import { DEFAULT_CHART_METRICS } from '@utils/metrics';
import * as types from './types';

export const initialState = {
  metric: DEFAULT_METRIC,
  chartData: {},
  metrics: DEFAULT_CHART_METRICS,
  loading: true,
  showError: false,
  liveDate: null,
};

const metricContainer = (state = initialState, action) => {
  switch (action.type) {
    case APPLY_PRESET_VIEW:
      return { ...state, ...action.view.metricsChartContainer };
    case types.RESET: {
      return initialState;
    }

    case types.SET_LIVE_DATE: {
      const { liveDate } = action;
      return update(state, {
        liveDate: {
          $set: liveDate,
        },
      });
    }

    case types.SELECTED_METRIC_CHART: {
      const { metricName } = action;
      return update(state, {
        metric: {
          $set: metricName,
        },
      });
    }
    case types.SAVE_CHART_DATA: {
      const { chartData } = action;
      return update(state, {
        $merge: {
          chartData,
        },
        loading: {
          $set: false,
        },
        showError: {
          $set: false,
        },
      });
    }
    case types.SET_LOADING_STATE: {
      return update(state, {
        loading: {
          $set: true,
        },
      });
    }
    case types.GET_CHART_DATA_FAILED: {
      return update(state, {
        loading: {
          $set: false,
        },
        showError: {
          $set: true,
        },
      });
    }

    case comparisonTypes.MODIFY_COMPARISON: {
      const { selectedMetric } = action.config;
      if (typeof selectedMetric === 'object') {
        return update(state, {
          selectedMetric: {
            $set: selectedMetric,
          },
        });
      }
      return state;
    }

    case types.SAVE_CHART_QUERY: {
      const { body } = action;
      return update(state, {
        query: {
          $set: body,
        },
      });
    }

    case types.SET_METRICS: {
      const { metrics } = action;
      return update(state, {
        metrics: {
          $set: metrics,
        },
      });
    }

    default:
      return state;
  }
};

export default metricContainer;
